import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import EmailTest from '../components/EmailTest';
import SEOHelmet from '../components/SEOHelmet';

const EmailTestPage = () => {
  return (
    <div style={{ backgroundColor: 'var(--bg-page)', minHeight: '100vh' }}>
      <SEOHelmet 
        title="Email System Test - Legal Document Specialist"
        description="Test the email delivery system for Legal Document Specialist website"
        keywords="email test, system test, legal document specialist"
        canonical="/email-test"
      />
      <Header />

      {/* Main Content */}
      <section style={{ backgroundColor: 'var(--bg-page)', padding: '160px 0 80px 0' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <h1 className="heading-1" style={{ marginBottom: '1rem' }}>
              Email System Test
            </h1>
            <p className="body-large" style={{ 
              color: 'var(--text-secondary)',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Test the email delivery system to verify order notifications and customer communications are working properly.
            </p>
          </div>
          
          <EmailTest />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EmailTestPage;